import { Goal } from '@/api/generated/model';
import { GoalForm } from '@/components/goals/GoalForm';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useLanguage } from '@/i18n/LanguageContext';

interface GoalDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (data: Partial<Goal>) => Promise<void>;
  onCancel: () => void;
  initialData?: Goal;
  mode: 'add' | 'edit';
}

export const GoalDialog = ({
  open,
  onOpenChange,
  onSubmit,
  onCancel,
  initialData,
  mode,
}: GoalDialogProps) => {
  const { t } = useLanguage();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{mode === 'add' ? t('goals.add') : t('goals.edit')}</DialogTitle>
          <DialogDescription>{t('goals.form.description')}</DialogDescription>
        </DialogHeader>
        <GoalForm initialData={initialData} onSubmit={onSubmit} onCancel={onCancel} />
      </DialogContent>
    </Dialog>
  );
};
